<template>
    <div>
        <footer>
            <div class="footer-area">
                <div class="footer-top">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer-widget">
                                    <div class="fw-logo mb-25">
                                        <a href="index.html"><img src="assets/img/logo/logo.png" alt="Apexa" /></a>
                                    </div>
                                    <div class="footer-content">
                                        <!-- <p>Felis consquat magnis fames sagittis ultrices plasodales porttitor quisque ultrice tempor turpis.</p> -->
                                        <div class="footer-social">
                                            <ul class="list-wrap">
                                                <li>
                                                    <a href="https://www.facebook.com/profile.php?id=61564851328916"
                                                        target="_blank"><i class="fab fa-facebook-f"></i></a>
                                                </li>
                                                <!-- <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-twitter"></i></a>
                                                </li> -->
                                                <!-- <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-instagram"></i></a>
                                                </li> -->
                                                <!-- <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-pinterest-p"></i></a>
                                                </li> -->
                                                <!-- <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-youtube"></i></a>
                                                </li> -->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Informasi</h4>
                                    <div class="footer-info-list">
                                        <ul class="list-wrap">
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-phone-call"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="javascript:void(0)">+62 823-4674-0564</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-envelope"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="javascript:void(0)">dtphp@konaweselatankab.go.id</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-pin"></i>
                                                </div>
                                                <div class="content">
                                                    <p>Kompleks Perkantoran Jalan Poros Andoolo-Kendari</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Top Links</h4>
                                    <div class="footer-link-list">
                                        <ul class="list-wrap">
                                            <li><router-link to="/berita">Berita</router-link></li>
                                            <li><router-link to="/dataPegawai">Data Pegawai</router-link></li>
                                            <li><router-link to="/sop">Standar Operasional Prosedur</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Foto Terbaru</h4>
                                    <div class="footer-instagram">
                                        <ul class="list-wrap">
                                            <li v-for="data in list_foto" :key="data.id">
                                                <a href="javascript:void(0)"><img :src="file_path + data.file"
                                                        alt="Apexa" /></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-7 order-0 order-lg-2">
                                <!-- <div class="footer-newsletter">
                                    <h4 class="title text-primary">Newsletter SignUp!</h4>
                                    <form action="#">
                                        <input type="text" placeholder="e-mail Type . . ." />
                                        <button class="btn btn-two" type="submit">Subscribe</button>
                                    </form>
                                </div> -->
                            </div>
                            <div class="col-lg-5">
                                <div class="copyright-text">
                                    <p>Hak Cipta © <a href="javascript:void(0)">diskominfo & sandi</a> | Semua Hak Dilindungi Undang-undang</p>
                                    <a href="javacript:void(0)">Syarat & Ketentuan Dukungan Kebijakan Privasi</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {

            id: "",
            list_foto: [],
            unit_kerja: UNIT_KERJA,

            file_path: this.$store.state.url.URL_APP + "uploads/",
            galeryku: {
                id: '',
                judul: '',
                deskripsi: '',
                file: '',
                unit_kerja: '',
                status: '',
                createBy: '',
                createAt: '',
            },
        }
    },


    methods: {
        getFoto: function () {
            fetch(this.$store.state.url.URL_FOTO, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                },
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_foto = res_data
                    // console.log(res_data);
                });
        },

        selectDataFoto: function (data) {
            this.galeryku = {
                id: data.id,
                judul: data.judul,
                deskripsi: data.deskripsi,
                file: data.file,
                unit_kerja: data.unit_kerja,
                status: data.status,
                createBy: data.createBy,
                createAt: data.createAt,
            };
            // console.log(data);
        },
    },


    mounted() {
        this.getFoto();
    },
}
</script>

<style></style>